import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
    className="fixed top-0 inset-x-0 z-50 bg-cream/85 backdrop-blur-md border-b border-[#E6E1D8]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 h-[70px] flex items-center justify-between">
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
        <img src="/logo.jpeg" alt="Chauffeur Privé DCR" className="h-11 w-11 object-cover rounded-sm" />
        <span className="hidden sm:block font-serif text-lg tracking-tight text-obsidian leading-tight">Chauffeur Privé <span className="italic text-gold">DCR</span></span>
      </Link>
      <nav className="hidden md:flex items-center gap-8 text-xs uppercase tracking-[0.2em] font-medium text-neutral-600">
        <button data-testid="nav-fleet-link" onClick={() => scrollToId("#flotte")} className="hover:text-obsidian transition-colors duration-300">Le Véhicule</button>
        <button data-testid="nav-manifesto-link" onClick={() => scrollToId("#manifeste")} className="hover:text-obsidian transition-colors duration-300">Manifeste</button>
        <Link to="/suivi" data-testid="nav-tracking-cta" className="hover:text-obsidian transition-colors duration-300">Suivi</Link>
      </nav>
      <div className="flex items-center gap-4">
        <a href="tel:+33651026078" data-testid="nav-phone-link" className="hidden lg:flex items-center gap-2 text-xs font-mono text-neutral-600 hover:text-obsidian transition-colors">
          <Phone size={13} /> 06 51 02 60 78
        </a>
        <button
          data-testid="nav-booking-cta"
          onClick={() => scrollToId("#reservation")}
          className="bg-obsidian text-cream text-xs uppercase tracking-[0.2em] px-5 py-2.5 hover:bg-gold hover:text-obsidian transition-colors duration-300"
        >
          Réserver
        </button>
      </div>
    </div>
  </motion.header>
);
